export const TABLE_CLASS = "w-full text-sm text-left";
export const THEAD_CLASS =
  "text-xs text-muted-foreground uppercase bg-muted border-b border-border sticky top-0 z-10";
export const TH_CLASS = "px-6 py-4 font-semibold";
export const TBODY_CLASS = "divide-y divide-border/50";
export const TR_CLASS = "hover:bg-muted/30 transition-colors cursor-pointer";
export const TD_CLASS = "px-6 py-4";
